import { ADCONFIG_DEFAULT } from "../constants";

export function getHeadline(article: Article) {
  return article.headlines && article.headlines.length
    ? article.headlines[0]
    : article.title;
}

export function getShortHeadline(article: Article) {
  return article.shortHeadline
    ? article.shortHeadline
    : article.headlines?.length
      ? article.headlines[0]
      : article.title;
}

export function getValidatedAdConfigOrDefault(
  article: Article | null | undefined,
) {
  if (!article) {
    return ADCONFIG_DEFAULT;
  }

  const config = article.adConfig ?? article.articleType?.adConfig;
  if (!config) {
    return ADCONFIG_DEFAULT;
  }

  // Validations
  const fields = [
    "platform",
    "breakpoint",
    "firstIndex",
    "between",
    "limit",
    // Always AP
    // "containerSuffix",
  ];
  const fieldsArePresent = fields.every((f) => f in config);
  const breakpointValid =
    Array.isArray(config.breakpoint) &&
    config.breakpoint.every((b) => typeof b === "string");
  const platformValid =
    Array.isArray(config.platform) &&
    config.platform.every((b) => typeof b === "string");
  const numFieldsValid =
    typeof config.firstIndex === "number" &&
    typeof config.between === "number" &&
    typeof config.limit === "number";
  const isValid =
    fieldsArePresent && breakpointValid && platformValid && numFieldsValid;

  return isValid ? config : ADCONFIG_DEFAULT;
}

export function getPlaintextDescription(article: Article) {
  // Flatten all content chunks
  // into a single string of all their values combined
  const getContentSubstring = (block: Content): string => {
    if (block?.content) {
      return (
        block.content
          .map((c: Content) => {
            return getContentSubstring(c);
          })
          .join("") + " "
      );
    }

    return block?.value ?? "";
  };

  const content = article.description?.json;
  return getContentSubstring(content).trim();
}
